import { memo, ReactElement } from 'react';

export interface SVGComponentProps {
  className?: string | undefined;
  title?: string | undefined;
}

interface SVGBaseProps {
  labeledBy: string;
  path: ReactElement;
  title: string;
  className?: string | undefined;
  viewBox?: string | undefined;
}

function SVGBase({
  className,
  labeledBy,
  path,
  title,
  viewBox = '0 0 32 32',
}: SVGBaseProps) {
  return (
    <svg
      aria-labelledby={labeledBy}
      className={className}
      role="img"
      version="1.1"
      viewBox={viewBox}
    >
      <title id={labeledBy}>{title}</title>
      {path}
    </svg>
  );
}

export default memo(SVGBase);
